import { render, staticRenderFns } from "./BonusMilesInfo.vue?vue&type=template&id=086499f4&scoped=true"
import script from "./BonusMilesInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./BonusMilesInfo.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BonusMilesInfo.vue?vue&type=style&index=0&id=086499f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086499f4",
  null
  
)

export default component.exports